import remainingChars from "surveylabJsAssets/page/_remaining-chars";

export default function(){
    $(function () {
        $('.sl-js-checkbox-free-checkmark').on('change', function (this: HTMLInputElement) {
            const checkboxID = $(this).attr('id');
            const textFieldID = '#' + checkboxID + '_free';
            const limitCharsID = '#' + checkboxID + '_limit';
            const limitChars = $(limitCharsID);

            $(textFieldID).val('');

            if (this.checked) {
                $(textFieldID).trigger('focus');
            } else {
                limitChars.hide();
            }
        });

        // On entering the free text field, select the corresponding checkbox
        $('.sl-js-checkbox-free-element .sl-free-text').on('focusin', function () {
            const $optionContainer = $(this).closest('.sl-js-option-container');
            const $checkmark = $optionContainer.find('.sl-js-checkbox-free-checkmark');
            $checkmark.prop("checked", true);
        });
    });
    remainingChars.initOnce();
}
